﻿import styles from "./MatchingIssues.module.css";

export default function MatchingIssues() {
  return (
    <div className={styles.container} aria-hidden>
      <div className={styles.ok}>
        <svg className={styles.icon} viewBox="0 0 24 24">
          {/* two nodes that slide in from each side but fail to link */}
          <circle className={`${styles.node} ${styles.nodeLeft}`} cx="6" cy="12" r="2.4" />
          <circle className={`${styles.node} ${styles.nodeRight}`} cx="18" cy="12" r="2.4" />
          {/* broken link: two stubs that recoil, leaving a gap */}
          <path className={`${styles.link} ${styles.linkLeft}`} d="M8.4 12h2.6" />
          <path className={`${styles.link} ${styles.linkRight}`} d="M13 12h2.6" />
        </svg>
      </div>
    </div>
  );
}
